import { Moment } from 'moment';

class DateRangeModel {
  public start: Moment | null = null;
  public end: Moment | null = null;
}

export default DateRangeModel;
